import {defaultFabricante, defaultFiltro} from './state'

export function setFabricantes(state, fabricantes) {
    state.fabricantes = fabricantes
}

export function setFabricante(state, fabricante) {
  state.fabricante = fabricante
}

export function resetFabricante(state) {
  state.fabricante = defaultFabricante()
}

/**
 * Mutación para limpiar el buscador de fabricantes.
 *
 * @export
 * @param {*} state
 */
export function resetFiltro(state) {
  Object.assign(state.filtro, defaultFiltro());
}

/**
 * Mutación para asignar la página en el buscador de fabricantes.
 *
 * @export
 * @param {*} state información del formulario de búsqueda.
 * @param {*} page pagina a asignar.
 */
export function setPage(state, page) {
  Object.assign(state.filtro, {page: page});
}

/**
 * Mutación para asignar la cantidad de registros por página en el buscador de fabricantes.
 *
 * @export
 * @param {*} state información del formulario de búsqueda.
 * @param {*} perPage cantidad de registros por página.
 */
export function setPerPage(state, perPage) {
  Object.assign(state.filtro, {perPage: perPage});
}

export function setLoading(state, loading) {
  state.loading = loading
}

/**
 * Mutación para asignar los procesos en segundo.
 *
 * Procesa asiganciones nuevas de los procedimeintos agendados para cargar de fabricantes.
 * 
 * @export
 * @param {*} state objecto para consultar estado actual.
 * @param {*} procesos información de los procesos.
 * @author Fernando Claros
 */
export function setProcesosEnSegundoPlano(state, procesos) {
  state.procesosEnSegundoPlano = procesos
}

/**
 * Mutación para asignar la página en el buscador de fabricantes.
 *
 * @export
 * @param {*} state objecto para consultar estado actual.
 * @param {*} page pagina a asignar.
 * @author Fernando Claros
 */
export function setFiltroProcesosAgendadosChangePage(state, page = 1) {
  state.filtroProcesosAgendados.page = page;
}
